module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/modal//task-bg.png?v=448bf176";